import { mountOcean } from './nike-one-piece-ocean.js';

// Separate decorative instance; never enroll the hero in the draw's state machine.
class NopHomeOcean extends HTMLElement {
  connectedCallback() {
    this.lifecycle?.abort();
    this.lifecycle = new AbortController();
    const options = { signal: this.lifecycle.signal };
    const start = () => {
      if (!this.isConnected || (this.ocean && this.ocean.metrics.status !== 'disposed')) return;
      this.ocean = mountOcean(this);
    };
    window.addEventListener('pageshow', start, options);
    this.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => this.disconnectedCallback(), options);
    start();
  }

  disconnectedCallback() {
    this.lifecycle?.abort();
    this.ocean?.dispose();
    this.ocean = null;
  }
}

if (!customElements.get('nop-home-ocean')) customElements.define('nop-home-ocean', NopHomeOcean);
